import { ConnectedAccountsLanding, useLanguageAwareRouting } from '@gofranz/common-components';
import { useRustyState } from '../../state';

export function AccountConnectedAccountsLandingPage() {
  const { api } = useRustyState.getState();
  const { createLanguageURL } = useLanguageAwareRouting();
  const profilePath = createLanguageURL('/account/profile');

  return (
    <ConnectedAccountsLanding
      api={api}
      connectedAccountsHref={`#${profilePath}`}
      onDone={() => {
        window.location.hash = profilePath;
      }}
      onDeleted={async () => {
        await useRustyState.getState().logout();
        window.location.replace(createLanguageURL('/'));
      }}
    />
  );
}
